/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
function n(i) {
  let t = { horizontal: "left", vertical: "bottom" };
  return i && (t.horizontal = "right"), t;
}
function o(i) {
  let t = { horizontal: "left", vertical: "top" };
  return i && (t.horizontal = "right"), t;
}
export {
  n as getAnchorAlign,
  o as getPopupAlign
};
